import React from 'react';
import HistoryIcon from '@mui/icons-material/History';
import { paths } from '@/app/paths';
import { ImportsListPage } from './ImportsListPage';
import { ImportReportPage } from './ImportReportPage';

export const importsRoutes = [
	{
		path: 'imports',
		element: <ImportsListPage />,
		handle: { title: 'Import history', icon: <HistoryIcon /> },
	},
	{
		// Its own page (with a results table and log), not a drawer over the history
		path: 'imports/:importId',
		element: <ImportReportPage />,
		handle: { title: 'Import report', icon: <HistoryIcon /> },
	},
];

export const importsNavItem = {
	text: 'History',
	icon: <HistoryIcon sx={{ fontSize: 30 }} />,
	link: `${paths.admin}/imports`,
};
